import React from 'react';
// Images
import SessionsVideo from '../../assets/video/lc6-1080.webm';
import SessionsVideo2 from '../../assets/video/lc5-1080.webm';
// Data
import { favoriteSessionsArray } from '../../utils/data/SessionsData';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
import SessionRatesSection from './SessionRatesSection';
import TouringContainer from '../tour/TouringContainer';

function SessionsPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-12 pt-6 pb-12'>
      {/* Intro section */}

      {/* Services */}
      <section className='grid w-full'>
        <div className='grid lg:grid-cols-2 gap-x-8 gap-y-8 p-6 lg:container lg:mx-auto'>
          {/* Video / Image */}
          <div className='grid'>
            <video
              src={SessionsVideo}
              className='w-full h-auto object-contain rounded-2xl shadow-lg max-h-[80vh]'
              autoPlay
              muted
              loop
              playsInline
              controls={false}
              aria-label='Lady Cinder — Neon-Gothic Dominatrix & Fire-Eater performing'
            />
          </div>
          <section className='grid w-full'>
            <article className='grid p-6 text-center gap-4 h-fit'>
              <p>
                Sessions are available both <strong>in person</strong> and{' '}
                <strong>online</strong>, with options including extended
                sessions, remote hypnosis, ritual indoctrination, and custom
                digital experiences.
              </p>
              <p>
                Whether you kneel before Me in the flesh or through the screen,
                I shape your submission into
                <strong> a spectacle you will never escape</strong>.
              </p>
            </article>
            {/* Favorite services */}
            <div className='hidden lg:grid items-center gap-4 h-fit'>
              <article className='grid gap-y-6'>
                <h4
                  className={`text-2xl md:text-3xl font-titleFont neon_text_thin_violet tracking-widest drop-shadow-lg text-center`}
                >
                  My signature devotions include:
                </h4>
                <ul className='grid gap-4 text-center'>
                  {favoriteSessionsArray.map((s, i) => (
                    <li key={i} className='grid gap-1'>
                      <span className='font-semibold'>
                        {typeof s === 'string' ? s : s.title}
                      </span>
                      {typeof s !== 'string' && s.description && (
                        <span className='text-white/80 text-sm leading-relaxed'>
                          {s.description}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </article>
            </div>
          </section>

          {/* Favorite services */}
          <div className='grid items-center gap-4 lg:hidden'>
            <article className='grid gap-y-6'>
              <h4
                className={`text-3xl lg:text-5xl font-semibold font-titleFont neon_text_thin_magenta text-center`}
              >
                FAVORITE SESSIONS
              </h4>
              <ul className='grid gap-4 text-center'>
                {favoriteSessionsArray.map((s, i) => (
                  <li key={i} className='grid gap-1'>
                    <span className='font-semibold'>
                      {typeof s === 'string' ? s : s.title}
                    </span>
                    {typeof s !== 'string' && s.description && (
                      <span className='text-white/80 text-sm leading-relaxed'>
                        {s.description}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* Rates */}
      <SessionRatesSection />

        <div className='grid gap-x-8 gap-y-8 p-6 lg:container lg:mx-auto'>
        <video
          src={SessionsVideo2}
          className='w-full h-auto object-contain rounded-2xl shadow-lg max-h-[80vh] mx-auto'
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          aria-label='Lady Cinder — Neon-Gothic Dominatrix & Fire-Eater performing'
        />
      </div>

      <TouringContainer />

      <SocialMediaCtaComponent />
    </main>
  );
}

export default SessionsPageMainContainer;
